<ng-container *ngIf=" permConfig.isViewAllowed">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body" [formGroup]="awbForm" (keydown.enter)="bindAwb()">
                        <div class="row">
                            <div class="col-md-3">
                                <label for="pieces" class="form-label">AWB Number<span class="mandatory">*</span></label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm" id="awbno"
                                        formControlName="txtAwbNo"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || awbForm.get('txtAwbNo').dirty) && awbForm.get('txtAwbNo').errors}"  appEnterDirective [onEnterKey]="true"/>
                                    <button type="submit" class="btn btn-primary btn-sm d-flex" (click)="bindAwb()">
                                        <i class="bx bx-search font-size-16 me-1"></i>
                                        Search
                                    </button>
                                    <div *ngIf="(isFormSubmitted || awbForm.get('txtAwbNo').dirty) && awbForm.get('txtAwbNo').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="awbForm.get('txtAwbNo').errors.required">AWB Number is required</span>
                                    </div>
                                    <!-- <div *ngIf=" (isFormSubmitted || awbForm.get('txtAwbNo').touched) && awbForm.get('txtAwbNo').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="awbForm.get('txtAwbNo').errors.maxlength">Awb No max length is 30 characters</span>
                                        <span *ngIf="awbForm.get('txtAwbNo').errors.pattern">Invalid Pattern.Only accept alphanumeric
                                            value.
                                        </span>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
    
                </div>
            </div>
        </div>
    
        <div class="row" *ngIf="showAwbQuery">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body card-summary">
                        <ul class="list-inline mb-0 d-flex flex-wrap align-items-center">
                            <li class="list-inline-item me-3">
                                <label class="form-label custom-label"><b>AWB Number:</b></label>
                                {{headerData?.awbNumber}}
                            </li>
                            <li class="list-inline-item me-3">
                                <label class="form-label custom-label me-2">
                                    <i class="bx bx-calendar me-1"></i>
                                    <b>Booking Date: </b>
                                </label>
                                {{headerData?.bookingDate}}
                            </li>
                            <li class="list-inline-item me-3">
                                <label class="form-label custom-label me-2">
                                    <i class="bx bx-calendar me-1"></i>
                                    <b>Expected Delivery Date: </b>
                                </label>
                                {{headerData?.expectedDeliveryDate}}
                            </li>
                            <li class="list-inline-item me-3">
                                <label class="form-label custom-label me-2">
                                    <i class="bx bx-check-square me-1"></i>
                                    <b>Status: </b>
                                </label>
                                <span [innerHTML]="getStatusLabel(headerData?.transactionstatus)"></span>
                            </li>
                            <li class="list-inline-item me-3">
                                <label class="form-label custom-label"><b>Origin:</b></label>
                                {{headerData?.origin}}
                            </li>
                            <li class="list-inline-item me-3">
                                <label class="form-label custom-label"><b>Destination:</b></label>
                                {{headerData?.destination}}
                            </li>
                            <!-- POD and KYC to the end -->
                            <div class="ms-auto d-flex">
                                <li ngbTooltip="AWB" placement="top" container="body" class="list-inline-item mx-1 btn btn-outline-light position-relative p-0 avatar-xs">
                                    <span class="avatar-title bg-transparent text-reset" (click)="getPrintType('awb')">
                                        <i class="bx bxs-detail text-primary font-size-14"></i>
                                    </span>
                                </li>
                                <li ngbTooltip="Commercial Invoice" placement="top" container="body" class="list-inline-item mx-1 btn btn-outline-light position-relative p-0 avatar-xs">
                                    <span class="avatar-title bg-transparent text-reset" (click)="getPrintType('commercial-invoice')">
                                        <i class="bx bxs-receipt text-primary font-size-14"></i>
                                    </span>
                                </li>
                                <li ngbTooltip="POD Image" placement="top" container="body" class="list-inline-item mx-1 btn btn-outline-light position-relative p-0 avatar-xs">
                                    <span class="avatar-title bg-transparent text-reset" (click)="showPODDocument()">
                                        <i class="bx bxs-file-image text-primary font-size-14"></i>
                                    </span>
                                </li>
                                <li ngbTooltip="KYC" placement="top" container="body" class="list-inline-item mx-1 btn btn-outline-light position-relative p-0 avatar-xs">
                                    <span class="avatar-title bg-transparent text-reset" (click)="openKycViewModal()">
                                        <i class="fas fa-fingerprint text-primary font-size-14"></i>
                                    </span>
                                </li>
                                <li *ngIf="formFiveCustomerUploadedFileURL" class="list-inline-item mx-1 btn btn-outline-light position-relative p-0 avatar-xs form-five-container">
                                    <a target="_blank" [href]="formFiveCustomerUploadedFileURL" style="font-size: 11px;">
                                        <b>Form 5</b>
                                    </a>
                                </li>
                            </div>
                        </ul>
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="showAwbQuery">
            <div class="col-md-12">
                <div class="card">
                    <ul ngbNav #justifiednav="ngbNav" [activeId]="1" class="nav nav-tabs nav-tabs-custom nav-justified">
                        <li [ngbNavItem]="1">
                            <a ngbNavLink>
                                <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                                <span class="d-none d-sm-block">Shipment Info</span>
                            </a>
                            <ng-template ngbNavContent>
                                <ng-template [ngTemplateOutlet]="ShipmentContent"></ng-template>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="2">
                            <a ngbNavLink>
                                <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                                <span class="d-none d-sm-block">Weight & Dimensions</span>
                            </a>
                            <ng-template ngbNavContent>
                                <ng-template [ngTemplateOutlet]="WeightContent"></ng-template>
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="3">
                            <a ngbNavLink>
                                <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                                <span class="d-none d-sm-block">Additional Info</span>
                            </a>
                            <ng-template ngbNavContent>
                                <ng-template [ngTemplateOutlet]="AdditionalContent"></ng-template>
                            </ng-template>
                        </li>
                    </ul>
                    <div class="card-body" style="padding: 6px;">
                        <div [ngbNavOutlet]="justifiednav"></div>
                        <ng-template #ShipmentContent>
                            <div class="row">
                                <div class="col-md-3 d-flex flex-grow-1">
                                    <div class="card flex-grow-1">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">Shipper Details
                                        </div>
                                        <div class="card-body tracking-default">
                                            <div class="row">
                                              <div class="col-12"><b>Name: </b>{{ shipper?.info?.name }}</div>
                                            </div>
                                            <div class="row">
                                              <div class="col-12"><b>Contact Person: </b>{{ shipper?.info?.contactperson }}</div>
                                            </div>
                                            <br>
                                            <div class="row">
                                              <div class="col-12">
                                                <b>Address: </b>{{ (shipper?.location?.address1 + (shipper?.location?.address2 ? ', ' + shipper?.location?.address2 : '')) + (shipper?.origindestloc ? ', ' + shipper?.origindestloc : '') }}
                                              </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12"><b>Pincode: </b>{{ shipper?.location?.pincode }}</div>
                                            </div>
                                            <br>
                                            <div class="row">
                                                <div class="col-12"><b>Tel: </b>{{ shipper?.location?.tel }}</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12"><b>Mob: </b>{{ shipper?.location?.mobileno }}</div>
                                            </div>
                                            <div class="row">
                                              <div class="col-12"><b>Email: </b>{{ shipper?.info?.emailid }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="col-md-3 d-flex flex-grow-1">
                                    <div class="card flex-grow-1">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">Consignee Details</div>
                                        <div class="card-body tracking-default">
                                            <div class="row">
                                                <div class="col-12"><b>Name: </b>{{ consignee?.info?.name }}</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12"><b>Contact Person: </b>{{ consignee?.info?.contactperson }}</div>
                                            </div>
                                            <br>
                                            <div class="row">
                                                <div class="col-12">
                                                    <b>Address: </b>{{ (consignee?.location?.address1 + (consignee?.location?.address2 ? ', ' + consignee?.location?.address2 : '')) + (consignee?.origindestloc ? ', ' + consignee?.origindestloc : '') }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12"><b>Pincode: </b>{{ consignee?.location?.pincode }}</div>
                                            </div>
                                            <br>
                                            <div class="row">
                                                <div class="col-12"><b>Tel: </b>{{ consignee?.location?.tel }}</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12"><b>Mob: </b>{{ consignee?.location?.mobileno }}</div>
                                            </div>
                                            <div class="row">
                                              <div class="col-12"><b>Email: </b>{{ consignee?.info?.emailid }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 d-flex flex-grow-1">
                                    <div class="card flex-grow-1">
                                        <div class=" card-header bg-transparent border-bottom text-uppercase">
                                            Progress
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ngx-simplebar>
                                                <ul class="verti-timeline list-unstyled">
                                                    <li class="event-list" *ngFor="let progress of progressRowData; let first = first" [class.active]="first">
                                                        <div class="event-timeline-dot">
                                                            <i class="bx bxs-right-arrow-circle font-size-18" [class.bx-fade-right]="first"></i>
                                                        </div>
                                                        <div class="media">
                                                            <div class="input-group me-3">
                                                                <h5 class="font-size-14" style="max-width: 90px;">
                                                                    {{formateDate(progress?.transactiondate)?.dateString}}<br/>
                                                                    <span class="font-size-10">{{formateDate(progress?.transactiondate)?.timeString}}</span>
                                                                </h5>
                                                                <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2 me-1"></i>
                                                                <div class="media-body">
                                                                    <div>
                                                                        <label [innerHTML]="getProgressLabel(progress?.transactionstatus, progress?.area)"></label>
                                                                    </div>
                                                                    <div *ngIf="progress?.remark">
                                                                        <label><b>{{progress?.remark}}</b></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </ngx-simplebar>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3 d-flex flex-grow-1">
                                    <div class="card flex-grow-1">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">Customer Details</div>
                                            <div class="card-body tracking-default">
                                                <div class="row">
                                                  <div class="col-12"><b>Type: </b>{{ customer?.customertype }}</div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-12"><b>Service Center: </b>{{ awbData?.servicecentername }}</div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-12"><b>Name: </b>{{ customer?.contactperson }}</div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-12"><b>Contact Person: </b>{{ customer?.name }}</div>
                                                </div>
                                                <br>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <b>Address: </b>{{ (customer?.location?.address1 || '') + (customer?.location?.address2 ? ', ' + customer?.location?.address2 : '') + (customer?.customer_full_address ? ', ' + customer?.customer_full_address : '') }}
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12"><b>Pincode: </b>{{ customer?.location?.pincode }}</div>
                                                </div>
                                                <br>
                                                <div class="row">
                                                  <div class="col-6"><b>Tel: </b>{{ customer?.location?.tel }}</div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-12"><b>Mob: </b>{{ customer?.location?.mobileno }}</div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-12"><b>Invoice No: </b>{{ customer?.invoiceno }}</div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-12"><b>Email: </b>{{ customer?.emailid }}</div>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                                <div class="col-md-3 d-flex flex-grow-1" *ngIf="!isCustomer">
                                    <div class="card flex-grow-1">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">Forwarding Details</div>
                                        <div class="card-body tracking-default">
                                            <div class="row">
                                              <div class="col-12"><b>Vendor Name: </b>{{ forwardingData?.vendorname }}</div>
                                            </div>
                                            <div class="row">
                                              <div class="col-12"><b>Delivery Vendor: </b>{{ forwardingData?.deliveryvendor }}</div>
                                            </div>
                                            <div class="row">
                                              <div class="col-12"><b>Forwarding Awb: </b>{{ forwardingData?.forwardingawbno }}</div>
                                            </div>
                                            <div class="row">
                                              <div class="col-12"><b>Delivery Awb: </b>{{ forwardingData?.deliveryawbno }}</div>
                                            </div>
                                          </div>
                                    </div>
                                </div>
    
                                <div class="col-md-6" *ngIf="!isCustomerAdmin">
                                    <div class="card">
                                        <div class=" card-header bg-transparent border-bottom text-uppercase">
                                            Comments
                                        </div>
                                        <div class="card-body tracking-default">
                                            <div class="row">
                                                <div class="col-md-12 grid-container">
                                                    <ag-grid-angular #agGrid2 style="width: 100%; height: 100%" id="myGrid2"
                                                        class="ag-theme-balham" [rowData]="commentRowData"
                                                        [columnDefs]="commentColumnDefs" [animateRows]="true"
                                                        [context]="context" [defaultColDef]="defaultColDef"
                                                        [gridOptions]="gridOptions" [suppressMenuHide]="true"
                                                        [pagination]="true" (gridReady)="onGridReady($event)">
                                                    </ag-grid-angular>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3 d-flex flex-grow-1">
                                    <div class="card flex-grow-1">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            POD Details
                                        </div>
                                        <div class="card-body tracking-default">
                                            <div class="row">
                                                <div class="col-12">
                                                    <b>Status Date & Time: </b>{{ podData?.createddttm }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <b>Expected Delivery Date: </b>{{ podData?.deliverydatetime }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <b>Receiver Name: </b>{{ podData?.receiver }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <b>Remark: </b>{{ podData?.remark }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <b>POD Receive Date: </b>{{ podData?.createddttm }}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <b>Telephone: </b>{{ podData?.telephone }}
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
    
                                <div class="col-md-9  d-flex flex-grow-1">
                                    <div class="card  flex-grow-1">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            Shipment Details
                                        </div>
                                        <div class="card-body tracking-default">
                                            <div class="row">
                                                <div class="col-md-3 mb-2">
                                                    <b>Product Type:</b> {{ shipmentDetailsData?.producttype }}
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <b>Product:</b> {{ shipmentDetailsData?.product }}
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <b>Vendor:</b> {{ shipmentDetailsData?.vendor }}
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <b>Service:</b> {{ shipmentDetailsData?.service }}
                                                </div>
                                            </div>
                                            
                                            <div class="row">
                                                <div class="col-md-3 mb-2">
                                                    <b>Shipment Value:</b> {{ shipmentDetailsData?.shipmentvalue }}
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <b>Pieces:</b> {{ shipmentDetailsData?.pieces }}
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <b>Actual Weight:</b> {{ shipmentDetailsData?.actualweight }}
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <b>Volumetric Weight:</b> {{ shipmentDetailsData?.volumetricweight }}
                                                </div>
                                            </div>
                                            
    
                                            <!-- <div class="row">
                                                <div class="col-md-3 mb-2">Content :</div>
                                            </div> -->
    
                                            <!-- <div class="row">
                                                <div class="col-md-3 mb-2">Bill Type :</div>
                                                <div class="col-md-3 mb-2">Manifest No :</div>
                                                <div class="col-md-3 mb-2">Invoice No :</div>
                                                <div class="col-md-3 mb-2">Customer Invoice :</div>
                                            </div> -->
    
                                            <!-- <div class="row">
                                                <div class="col-md-3 mb-2">Payment :</div>
                                                <div class="col-md-3 mb-2">Inscan Weight :</div>
                                                <div class="col-md-3 mb-2">Club :</div>
                                                <div class="col-md-3 mb-2">Ref.No :</div>
                                            </div> -->
    
                                            <!-- <div class="row">
                                                <div class="col-md-3 mb-2">MasterAWB No :</div>
                                                <div class="col-md-3 mb-2">eAWB No :</div>
                                                <div class="col-md-3 mb-2">Complaint No :</div>
                                                <div class="col-md-3 mb-2">Log User :</div>
                                            </div> -->
    
                                            <!-- <div class="row">
                                                <div class="col-md-3 mb-2">
                                                    DRS Vehicle :
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    DRS Driver :
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    Manifest Vehicle :
                                                </div>
                                                <div class="col-md-3 mb-2">Manifest Driver :</div>
                                                <div class="col-md-3 mb-2">Assigned To :</div>
                                                <div class="col-md-3 mb-2">Charge Type :</div>
                                                <div class="col-md-3 mb-2">Pincode Type :</div>
                                            </div> -->
    
                                            <!-- <div class="row">
                                                <div class="col-md-3 mb-2" *ngIf="billingtype == 'COD'">Pending/Balance Amount :</div>
                                            </div> -->
    
                                            <!-- <div class="row">
                                                <div class="col-md-12 mb-2"><b>Remark :</b></div>
                                            </div> -->
    
                                            <!-- <div class="row">
                                                <div class="col-md-12 mb-2"><b>Instruction :</b></div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #WeightContent>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card ">
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid4 style="width: 100%; height: 100%" id="myGrid4"
                                                class="ag-theme-balham" [rowData]="volumetricRowData"
                                                [columnDefs]="volumetricColumnDefs" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [pagination]="true"
                                                [enableCellTextSelection]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
    
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card ">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            Item Details
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid5 style="width: 100%; height: 100%" id="myGrid5"
                                                class="ag-theme-balham" [rowData]="itemDetailsRowData"
                                                [columnDefs]="itemDetailsColumnDefs" [animateRows]="true"
                                                [context]="context" [defaultColDef]="defaultColDef"
                                                [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                                                (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #AdditionalContent>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card ">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            Manifest Details
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid6 style="width: 100%; height: 100%" id="myGrid6"
                                                class="ag-theme-balham" [rowData]="manifestRowData"
                                                [columnDefs]="manifestColumnDefs" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [pagination]="true"
                                                [enableCellTextSelection]="true" (gridReady)="onGridReady($event) ">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            DRS Details
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid9 style="width: 100%; height: 100%" id="myGrid9"
                                                class="ag-theme-balham" [rowData]="drsDetailsRowData"
                                                [columnDefs]="drsDetailsColumnDefs" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [pagination]="true"
                                                [enableCellTextSelection]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="card">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            TAT Details
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid9 style="width: 100%; height: 100%" id="myGrid9"
                                                class="ag-theme-balham" [rowData]="tatDetailsRowData"
                                                [columnDefs]="tatDetailsColumnDefs" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [pagination]="true"
                                                [enableCellTextSelection]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            Uploaded Document
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid9 style="width: 100%; height: 100%" id="myGrid9"
                                                class="ag-theme-balham" [rowData]="uploadedDocumentRowData"
                                                [columnDefs]="uploadedDocumentsColumnDefs" [animateRows]="true"
                                                [context]="context" [defaultColDef]="defaultColDef"
                                                [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                                                [enableCellTextSelection]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row" *ngIf="detailPermission.charges">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            Charges
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid9 style="width: 100%; height: 100%" id="myGrid9"
                                                class="ag-theme-balham" [rowData]="chargeRowData"
                                                [columnDefs]="chargeColumnDefs" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [pagination]="true"
                                                [enableCellTextSelection]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row" *ngIf="detailPermission.charges">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            Charges Details
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid10 style="width: 100%; height: 100%" id="myGrid10"
                                                class="ag-theme-balham" [rowData]="chargeDetailsRowData"
                                                [columnDefs]="chargeDetailsColumnDefs" [animateRows]="true"
                                                [context]="context" [defaultColDef]="defaultColDef"
                                                [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                                                [enableCellTextSelection]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row" *ngIf="detailPermission.forwardinginfo && !isCustomer">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            Forwarding Charges
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid9 style="width: 100%; height: 100%" id="myGrid9"
                                                class="ag-theme-balham" [rowData]="forwardingChargeRowData"
                                                [columnDefs]="chargeColumnDefs" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [pagination]="true"
                                                [enableCellTextSelection]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row" *ngIf="detailPermission.forwardinginfo && !isCustomer">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">
                                            Forwarding Charges Details
                                        </div>
                                        <div class="card-body tracking-default">
                                            <ag-grid-angular #agGrid10 style="width: 100%; height: 100%" id="myGrid10"
                                                class="ag-theme-balham" [rowData]="forwardingChargeDetailsRowData"
                                                [columnDefs]="chargeDetailsColumnDefs" [animateRows]="true"
                                                [context]="context" [defaultColDef]="defaultColDef"
                                                [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                                                [enableCellTextSelection]="true" (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div *ngIf="showAwbQuery"> -->
    
    
    
    
        <!-- <div class="row" *ngIf="isCustomer"> -->
        <!-- <div class="col-md-6">
                    <div class="card ">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            Progress
                        </div>
                        <div class="card-body tracking-default">
                            <div class="row">
                                <div class="col-md-12 grid-container">
                                    <ag-grid-angular #agGrid1 style="width: 100%; height: 100%" id="myGrid1"
                                        class="ag-theme-balham" [rowData]="progressRowData"
                                        [columnDefs]="progressColumnDefs" [animateRows]="true"
                                        [context]="context" [defaultColDef]="defaultColDef"
                                        [gridOptions]="gridOptions" [suppressMenuHide]="true"
                                        [pagination]="true" (gridReady)="onGridReady($event)">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
    
    
    
        <!-- </div> -->
    
        <!--<div class="row">
                 <div class="col-md-4">
                    <div class="card ">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            OBC Details
                        </div>
                        <div class="card-body tracking-default">
                            <div class="row mb-2">
                                Flight No:
                            </div>
                            <div class="row mb-2">
                                Airlines:
                            </div>
                            <div class="row mb-2">
                                Mast AWB No:
                            </div>
                            <div class="row mb-2">
                                CD No:
                            </div>
                            <div class="row mb-2">
                                OBC Name:
                            </div>
                        </div>
                    </div>
                </div> -->
        <!-- <div class="col-md-8">
                    <div class="card ">
                        <div class="card-header bg-transparent border-bottom text-uppercase">
                            Shipment Log
                        </div>
                        <div class="card-body tracking-default">
                            <div class="row">
                                <div class="col-md-12 grid-container">
                                    <ag-grid-angular #agGrid3 style="width: 100%; height: 100%" id="myGrid3"
                                        class="ag-theme-balham" [rowData]="shipmentRowData"
                                        [columnDefs]="shipmentColumnDefs" [animateRows]="true" [context]="context"
                                        [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                        [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReady($event)">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>-->
    
        <!-- <div class="row">
                <div class="col-12">
                    <div class="card">
                        <ul ngbNav #justifiednav="ngbNav" [activeId]="1" class="nav-pills bg-light rounded nav">
                            <li [ngbNavItem]="1" *ngIf="isCustomer">
                                <a ngbNavLink>
                                    <span class="d-block d-sm-none" (click)="isFormSubmitted=true"><i
                                            class="fas fa-truck"></i></span>
                                    <span class="d-none d-sm-block" (click)="isFormSubmitted=true">Shipping Info</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <ng-template [ngTemplateOutlet]="ShippingContent"></ng-template>
                                </ng-template>
                            </li>
    
                            <li [ngbNavItem]="2">
                                <a ngbNavLink>
                                    <span class="d-block d-sm-none" (click)="isFormSubmitted=true"><i
                                            class="fas fa-info-circle"></i></span>
                                    <span class="d-none d-sm-block" (click)="isFormSubmitted=true">Additional
                                        Info</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <ng-template [ngTemplateOutlet]="AdditionalContent"></ng-template>
                                </ng-template>
                            </li>
                        </ul>
                        <div [ngbNavOutlet]="justifiednav"></div>
    
                    </div>
    
                </div>
            </div> -->
    
        <!-- <ng-template #ShippingContent [formGroup]="shippingInfoForm">
    
    
                <div class="row">
                    <div class="col-md-12">
                        <div class="card ">
                            <div class="card-header bg-transparent border-bottom text-uppercase">
                                Appoinment Details
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-3 mb-2">
                                        FBA Number :
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        FC Code :
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        Appoinment PCS :
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        Appointment Delivery Date :
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col-md-3 mb-2">
                                        Appointment ID:
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="col-md-12">
                        <div class="card ">
                            <div class="card-header bg-transparent border-bottom text-uppercase">
                                Transit Details
                            </div>
                            <div class="card-body" formGroupName="transitdetails">
                                <div class="row">
                                    <div class="col-md-3 mb-2">
                                        Delay Days :
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        Transit Days :
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <div class="mb-2">
                                            <label for="excepteddelvdate">Excepted Delv Date</label>
                                            <input type="text" id="excepteddelvdate" class="form-control form-control-sm"
                                                formControlName="txtExpectedDelvDate"  />
                                        </div>
                                    </div>
                                    <div class="col-md-3 mb-2">
                                        <div class="mb-2">
                                            <label for="type">Type</label>
                                            <ng-select type="text" id="type" formControlName="ddlType">
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template> -->
    
        <!-- <ng-template #AdditionalContent [formGroup]="additionalInfoForm"> -->
        <!-- <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-3">
                                        <label for="" class="form-label">Expand/Collapse All</label>
                                        <div class="form-check form-switch form-switch-md mb-2">
                                            <input id="awbchk" type="checkbox" (change)="expandCollapseAll()"
                                                class="form-check-input" formControlName="txtStatus">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
    
    
        <!-- <div class="row">
                    <div class="col-md-12">
                        <div class="card ">
                            <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">
                                <ngb-panel id="manifestinscan">
                                    <ng-template ngbPanelTitle class="text-black">
                                        <i class="text-primary me-1"></i>Manifest Inscan
                                    </ng-template>
                                    <ng-template ngbPanelContent>
                                        <div class="col-md-12 grid-container">
                                            <ag-grid-angular #agGrid7 style="width: 100%; height: 100%" id="myGrid7"
                                                class="ag-theme-balham" [rowData]="manifestInscanRowData"
                                                [columnDefs]="manifestInscanColumnDefs" [animateRows]="true"
                                                [context]="context" [defaultColDef]="defaultColDef"
                                                [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                                                (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>
                </div> -->
    
        <!-- <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">
                                <ngb-panel id="manifestdetails">
                                    <ng-template ngbPanelTitle class="text-black">
                                        <i class="text-primary me-1"></i>Manifest Details
                                    </ng-template>
                                    <ng-template ngbPanelContent>
                                        <div class="col-md-12 grid-container">
                                            <ag-grid-angular #agGrid8 style="width: 100%; height: 100%" id="myGrid8"
                                                class="ag-theme-balham" [rowData]="manifestDetailsRowData"
                                                [columnDefs]="manifestDetailsColumnDefs" [animateRows]="true"
                                                [context]="context" [defaultColDef]="defaultColDef"
                                                [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                                                (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>
                </div> -->
    
        <!-- <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">
                                <ngb-panel id="drsdetails">
                                    <ng-template ngbPanelTitle class="text-black">
                                        <i class="text-primary me-1"></i>DRS Details
                                    </ng-template>
                                    <ng-template ngbPanelContent>
                                        <div class="col-md-12 grid-container">
                                            <ag-grid-angular #agGrid9 style="width: 100%; height: 100%" id="myGrid9"
                                                class="ag-theme-balham" [rowData]="drsDetailsRowData"
                                                [columnDefs]="drsDetailsColumnDefs" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [pagination]="true"
                                                (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>
                </div> -->
    
        <!-- <div class="row">
                    <div class="col-md-12">
                        <div class="card ">
                            <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">
                                <ngb-panel id="awbcharges">
                                    <ng-template ngbPanelTitle class="text-black">
                                        <i class="text-primary me-1"></i> AWB Charges
                                    </ng-template>
                                    <ng-template ngbPanelContent>
                                        <div class="col-md-12 grid-container">
                                            <ag-grid-angular #agGrid10 style="width: 100%; height: 100%" id="myGrid10"
                                                class="ag-theme-balham" [rowData]="awbRowData"
                                                [columnDefs]="awbChargesColumnDefs" [animateRows]="true" [context]="context"
                                                [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                                                [suppressMenuHide]="true" [pagination]="true"
                                                (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>
                </div> -->
    
        <!--<div class="row">
                     <div class="col-md-12">
                        <div class="card ">
                            <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">
                                <ngb-panel id="delivercharges">
                                    <ng-template ngbPanelTitle class="text-black">
                                        <i class="text-primary me-1"></i> Deliver Charges
                                    </ng-template>
                                    <ng-template ngbPanelContent>
                                        <div class="col-md-12 grid-container">
                                            <ag-grid-angular #agGrid11 style="width: 100%; height: 100%" id="myGrid11"
                                                class="ag-theme-balham" [rowData]="deliveryRowData"
                                                [columnDefs]="deliverChargesColumnDefs" [animateRows]="true"
                                                [context]="context" [defaultColDef]="defaultColDef"
                                                [gridOptions]="gridOptions" [suppressMenuHide]="true" [pagination]="true"
                                                (gridReady)="onGridReady($event)">
                                            </ag-grid-angular>
                                        </div>
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>
                </div> -->
    
        <!-- <div class="row">
                    <div class="col-md-6">
                        <div class="card ">
                            <div class="card-header bg-transparent border-bottom text-uppercase">
                                Upload Document
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-2">
                                            <label for="detail">Detail</label>
                                            <input type="text" id="detail" class="form-control form-control-sm"  />
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="mb-2">
                                            <div class="input-group mb-2">
                                                <input id="choosefile" type="file" class="form-control form-control-sm"  />
                                                <button type="button" class="btn btn-primary btn-sm">
                                                    <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                                                    Upload
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
        <!-- </ng-template> -->
        <!-- </div> -->
    
    </div>
    </ng-container>
    
    <ng-container *ngIf="!permConfig.isViewAllowed">
        <app-forbidden></app-forbidden>
    </ng-container>